import { http } from "./http";

// 로그인 요청 타입
export interface LoginRequest {
  email: string;
  password: string;
  isLongToken?: boolean;
  deviceId?: string;
}

// 로그인 응답 타입 (레거시 스펙)
export interface LoginContent {
  id: number;
  grantType: string;
  accessToken: string;
  refreshToken: string;
  accessTokenExpiresIn: number;
  deviceId: string | null;
  fileId: number | null;
  photoId: number | null;
  name: string;
  positionName: string;
  allowedSystem: number;
  companyName: string;
  tokenType?: string;
}

export interface LoginResponse {
  content: LoginContent;
  msg: string;
}

// 토큰 재발급 요청 타입
export interface TokenRefreshRequest {
  accessToken: string;
  refreshToken: string;
}

export interface TokenRefreshResponse {
  content: LoginContent;
  msg: string;
}

// 기본 디바이스 ID 생성
const getDefaultDeviceId = () =>
  typeof navigator !== "undefined" ? navigator.userAgent : "unknown-device";

export const authApi = {
  /**
   * 로그인
   */
  login: ({ email, password, isLongToken = true, deviceId }: LoginRequest) =>
    http.post<LoginResponse>("/auth/login", {
      email,
      passwd: password,
      isLongToken,
      deviceId: deviceId || getDefaultDeviceId(),
    }),

  /**
   * 토큰 재발급
   */
  reissueToken: (tokens: TokenRefreshRequest) =>
    http.post<TokenRefreshResponse>("/auth/retoken", {
      accessToken: tokens.accessToken,
      refreshToken: tokens.refreshToken,
    }),

  /**
   * 로그아웃
   */
  logout: ({ accessToken, refreshToken }: TokenRefreshRequest) =>
    http.delete("/auth/retoken", {
      data: { accessToken, refreshToken },
    }),
};
